import { render, staticRenderFns } from "./zhaopinxinxi1.vue?vue&type=template&id=316c7aeb&scoped=true&"
import script from "./zhaopinxinxi1.vue?vue&type=script&lang=js&"
export * from "./zhaopinxinxi1.vue?vue&type=script&lang=js&"
import style0 from "./zhaopinxinxi1.vue?vue&type=style&index=0&id=316c7aeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316c7aeb",
  null
  
)

export default component.exports